import { useCallback, useRef } from 'react';
export function useFocusWithin(props) {
    var propsRef = useRef(props);
    var stateRef = useRef({ within: false });
    propsRef.current = props;
    var onFocus = useCallback(function (event) {
        var _a = propsRef.current, onFocusWithin = _a.onFocusWithin, onFocusWithinChange = _a.onFocusWithinChange;
        var state = stateRef.current;
        if (!state.within) {
            state.within = true;
            onFocusWithin === null || onFocusWithin === void 0 ? void 0 : onFocusWithin(event);
            onFocusWithinChange === null || onFocusWithinChange === void 0 ? void 0 : onFocusWithinChange(true);
        }
    }, []);
    var onBlur = useCallback(function (event) {
        var _a = propsRef.current, onBlurWithin = _a.onBlurWithin, onFocusWithinChange = _a.onFocusWithinChange;
        var state = stateRef.current;
        if (state.within && !event.currentTarget.contains(event.relatedTarget)) {
            state.within = false;
            onBlurWithin === null || onBlurWithin === void 0 ? void 0 : onBlurWithin(event);
            onFocusWithinChange === null || onFocusWithinChange === void 0 ? void 0 : onFocusWithinChange(false);
        }
    }, []);
    var focusWithinProps = {};
    if (!props.disabled && (props.onFocusWithin || props.onBlurWithin || props.onFocusWithinChange)) {
        focusWithinProps.onFocus = onFocus;
        focusWithinProps.onBlur = onBlur;
    }
    return {
        focusWithinProps: focusWithinProps,
    };
}
